const grayScale = {
  black: '#000000',
  gray800: '#666666',
  gray700: '#999999',
  gray500: '#bcbcbc',
  gray400: '#d6d6d6',
  gray200: '#f5f5f5',
  white: '#ffffff',
}

const orange = {
  orange: '#ff540f',
  lightOrange: '#ffede3',
}

const yellow = {
  yellow: '#ffd267',
  lightYellow: '#fff7e0',
  latte: '#bf8650',
}

const statusColor = {
  ban: '#e03131',
}

export interface ColorSet {
  black: string
  gray800: string
  gray700: string
  gray500: string
  gray400: string
  gray200: string
  white: string
  orange: string
  lightOrange: string
  yellow: string
  lightYellow: string
  latte: string
  ban: string
}

const colors = {
  ...orange,
  ...yellow,
  ...grayScale,
  ...statusColor,
}

export type ColorType = keyof typeof colors

export default colors
